import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SSOStagesMessages } from '../constants';
import { initApp } from '../actions';

class App extends Component {
  componentDidMount() {
    this.props.initApplication();
  }

  render() {
    const { error, ssoStage } = this.props.application;
    const content = error ? error : SSOStagesMessages[ssoStage];
    return <div>{content}</div>;
  }
}

App.propTypes = {
  initApplication: PropTypes.func,
};

const mapStateToProps = state => ({
  application: state.application,
});

const mapDispatchToProps = dispatch => ({
  initApplication() {
    dispatch(initApp());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js